"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var styled_components_1 = require("styled-components");

var styled_1 = require("./styled");

var Children = React.Children;
var LeftRightContainer = styled_components_1.default(styled_1.Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    justify-content: space-between;\n"], ["\n    justify-content: space-between;\n"])));

var Empty = function Empty() {
  return React.createElement("div", null);
};

Empty.displayName = 'ReactContainers-Empty';

exports.LeftRightSection = function (props) {
  var children = Children.toArray(props.children || []);
  return React.createElement(LeftRightContainer, null, children[0] ? children[0] : React.createElement(Empty, null), children[1] ? children[1] : React.createElement(Empty, null));
};

exports.default = exports.LeftRightSection;
var templateObject_1;